<template>
    <div class="field-container-2">
        <div class="regular-type-header">
            {{header}}
        </div>
        <div class="datetime-pickers-container">
            <div class="date-picker-container">
                <v-menu
                        :close-on-content-click="false"
                        v-model="dateState"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                >
                    <v-text-field
                            slot="activator"
                            hint="Pick date"
                            :persistent-hint="true"
                            color="accent"
                            v-model="dateValue"
                            :rules="validationRules"
                            :required="isRequired"
                            readonly
                    ></v-text-field>
                    <v-date-picker
                            v-model="dateValue"
                            no-title
                            @input="dateInputHandler"></v-date-picker>
                </v-menu>
            </div>
            <!--<div class="time-picker-container">-->
                <!--<v-menu-->
                        <!--:close-on-content-click="false"-->
                        <!--v-model="timeState"-->
                        <!--:nudge-right="40"-->
                        <!--lazy-->
                        <!--transition="scale-transition"-->
                        <!--offset-y-->
                        <!--full-width-->
                        <!--max-width="290px"-->
                        <!--min-width="290px"-->
                <!--&gt;-->
                    <!--<v-text-field-->
                            <!--slot="activator"-->
                            <!--hint="Pick time (optional)"-->
                            <!--:persistent-hint="true"-->
                            <!--color="accent"-->
                            <!--v-model="timeValue"-->
                            <!--readonly-->
                    <!--&gt;</v-text-field>-->
                    <!--<v-time-picker-->
                            <!--v-model="timeValue"-->
                            <!--header-color="accent"-->
                            <!--format="ampm"-->
                            <!--@input="timeInputHandler"-->
                    <!--&gt;</v-time-picker>-->
                <!--</v-menu>-->
            <!--</div>-->
        </div>
        <div class="hint-text">
            {{description}}
        </div>

    </div>

</template>

<script>
    import {
        EVENT_INPUT,
        EVENT_TOUCHED,
        EVENT_VALIDATION_STATE,
        DEFAULT_LOCALE,
        GET_LOCALE_DISPLAY_NAME
    } from '../../services/constants'
    import moment from '../../services/moment'

    export default {
        name: 'sfr-datetime-field',
        props: ['field', 'valid', 'inputValue'],
        model: {
            prop: 'inputValue',
            event: EVENT_INPUT
        },
        data: function () {
            return {
                isRequired: this.field.required,
                defaultToolbarOptions: [ // list of options: https://github.com/davidroyer/vue2-editor/issues/36
                    ['bold', 'italic', 'underline'],
                    [{'list': 'ordered'}, {'list': 'bullet'}],
                    // ['image', 'code-block']
                ],
                dateValue: this.inputValue ? moment.iso8601ToDateString(this.inputValue) : null,
                dateState: false,
                timeValue: this.inputValue ? moment.iso8601To24HrTimeString(this.inputValue) : null,
                timeState: false,
                validationText: '',
            }
        },
        computed: {
            header: function () {
                return this.computeFieldHeader(this.field)
            },
            isValid: function () {
                return this.valid
            },
            validationRules: function () {
                return [
                    this.isRequired ? v => !!v || `${this.field.name} is required` : () => true,
                ]
            },
            description: function () {
                const currentLocale = this.$store.state.locale.currentLocale
                return currentLocale === DEFAULT_LOCALE ? this.field.description : `${this.field.description} (${this.$store.getters[GET_LOCALE_DISPLAY_NAME](currentLocale)})`
            },
        },
        methods: {
            computeFieldHeader: function (field) {
                return `${field.name}${field.required ? '* ' : ''}:`
            },
            emitInput: function ($event) {
                this.$emit(EVENT_INPUT, moment.dateAndTimeStringsToISO8601UTC(this.dateValue, this.timeValue))
                this.$emit(EVENT_TOUCHED, true)
            },
            dateInputHandler: function ($event) {
                this.dateState = false
                this.emitInput($event)
                this.validate()
            },
            timeInputHandler: function ($event) {
                this.timeState = false
                this.emitInput($event)
            },
            validate: function () {
                const validationResult = !this.validationRules.map(ruleFunc => {
                    const ruleResult = ruleFunc(this.dateValue)
                    if (ruleResult !== true) {
                        this.validationText = ruleResult
                    } else {
                        this.validationText = ''
                    }
                    return ruleResult === true
                }).some(validationResult => {
                    return validationResult === false
                })
                if (validationResult !== this.isValid) {
                    this.emitValidationState(validationResult)
                }
            },

            emitValidationState: function ($event) {
                this.$emit(EVENT_VALIDATION_STATE, $event)
            },
        },
        created: function () {
            this.validate()
        },
    }
</script>

<style scoped lang="scss">
    @import "../../meta";

    .field-container-1 {
        margin: 2em 0;
        .field-container-2 {
            padding: 0 1em;
            $border-width: 3px;
            border-left: $border-width solid $accent;
            border-radius: $border-width;
        }
    }

    .regular-type-header {
        font-size: 14px;
        .input-group {
            padding: 0px;
        }
    }

    .datetime-pickers-container {
        display: flex;

        .date-picker-container {
            margin: 0 1em 0 0;
            width: 100%;
        }
    }

    .hint-text {
        @extend %manual-description;
    }


</style>
